export enum tradeDeskTabsList {
    ORDERS = "_orders",
    // POSITIONS     = "_positions",
    HISTORY = "_history",
    ORDERS_PENDING = "_ordersPending"
}

export function tradeDeskTabsParams(): object {
    let tabsParams: { id: string; label: string }[] = [
        { id: tradeDeskTabsList.ORDERS, label: "Trade" },
        { id: tradeDeskTabsList.ORDERS_PENDING, label: "Pending Orders" },
        //     { "id": tradeDeskTabsList.POSITIONS, "label": "Positions" },
        { id: tradeDeskTabsList.HISTORY, label: "History" }
    ];
    return tabsParams;
}

export function gettradeDeskTabsList(): string[][] {
    let res: string[][] = [];
    for (const n in tradeDeskTabsList) {
        if (tradeDeskTabsList.hasOwnProperty(n)) {
            res.push([n, (<any>tradeDeskTabsList)[n]]);
        }
    }
    return res;
}
